import { render, staticRenderFns } from "./FileDown.vue?vue&type=template&id=56313084"
import script from "./FileDown.vue?vue&type=script&lang=js"
export * from "./FileDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports